const REQUIRED_FIELDS = [
	{ name: 'contact_name', label: 'Họ và tên' },
	{ name: 'contact_phone', label: 'Số điện thoại' },
	{ name: 'contact_email', label: 'Email' },
	{ name: 'contact_topic', label: 'Chủ đề' },
	{ name: 'contact_message', label: 'Nội dung tin nhắn' },
];

function isValidEmail(value) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

const PHONE_PATTERN = /^(0|\+84)(3[2-9]|5[25689]|7[06-9]|8[1-9]|9[0-46-9])[0-9]{7}$/;

function isValidPhone(value) {
	return PHONE_PATTERN.test(value.replace(/[\s.-]/g, ''));
}

function showError(errorEl, message) {
	errorEl.textContent = message;
	errorEl.hidden = false;
}

function clearError(errorEl) {
	errorEl.hidden = true;
	errorEl.textContent = '';
}

function showFieldError(form, name, message) {
	const fieldErrorEl = form.querySelector(`[data-error-for="${name}"]`);
	if (fieldErrorEl) {
		fieldErrorEl.textContent = message;
		fieldErrorEl.hidden = false;
	}
}

function clearFieldErrors(form) {
	form.querySelectorAll('[data-error-for]').forEach((el) => {
		el.hidden = true;
		el.textContent = '';
	});
}

function validateContactForm(form) {
	clearFieldErrors(form);
	let isValid = true;

	REQUIRED_FIELDS.forEach(({ name, label }) => {
		if (!form.elements[name].value.trim()) {
			showFieldError(form, name, `Vui lòng nhập ${label}.`);
			isValid = false;
		}
	});

	const phone = form.elements.contact_phone.value.trim();
	if (phone && !isValidPhone(phone)) {
		showFieldError(form, 'contact_phone', 'Số điện thoại không hợp lệ.');
		isValid = false;
	}

	const email = form.elements.contact_email.value.trim();
	if (email && !isValidEmail(email)) {
		showFieldError(form, 'contact_email', 'Email không hợp lệ.');
		isValid = false;
	}

	return isValid;
}

document.addEventListener('DOMContentLoaded', () => {
	const form = document.getElementById('contact-form');
	if (!form) {
		return;
	}

	const errorEl = document.getElementById('contact-form-error');
	const successEl = document.getElementById('contact-form-success');

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		clearError(errorEl);
		successEl.hidden = true;

		if (!validateContactForm(form)) {
			return;
		}

		const submitButton = form.querySelector('button[type="submit"]');
		const originalLabel = submitButton.textContent;
		submitButton.disabled = true;
		submitButton.textContent = 'Đang gửi...';

		const body = new URLSearchParams({
			action: 'vbp_send_contact_message',
			nonce: window.vbpData.contactNonce,
			name: form.elements.contact_name.value.trim(),
			phone: form.elements.contact_phone.value.trim(),
			email: form.elements.contact_email.value.trim(),
			topic: form.elements.contact_topic.value,
			message: form.elements.contact_message.value.trim(),
		});

		fetch(window.vbpData.ajaxUrl, { method: 'POST', body })
			.then((res) => res.json())
			.then((data) => {
				submitButton.disabled = false;
				submitButton.textContent = originalLabel;

				if (data.success) {
					successEl.textContent = data.data.message;
					successEl.hidden = false;
					form.reset();
					return;
				}

				if (data.data?.field) {
					showFieldError(form, data.data.field, data.data.message);
					return;
				}

				showError(errorEl, data.data?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
			})
			.catch(() => {
				submitButton.disabled = false;
				submitButton.textContent = originalLabel;
				showError(errorEl, 'Có lỗi xảy ra, vui lòng thử lại.');
			});
	});
});
